import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { AnalyzeTypeType, AssemblySplitModeType, PartTypeType } from "shared";

export type CheckPartDto = ClientInferResponseBody<typeof contract.parts.check, 200>;

export const checkPart = async (
  id: string,
  {
    force = false,
    analyzeType = "COMPUTE_ALL",
    partType,
    shouldUpdatePartType = true,
    shouldPredictAfterAnalyze = false,
    quoteRequestLineId,
    assemblySplitMode,
  }: {
    force?: boolean;
    analyzeType?: AnalyzeTypeType;
    partType?: PartTypeType;
    shouldUpdatePartType?: boolean;
    shouldPredictAfterAnalyze?: boolean;
    quoteRequestLineId?: string;
    assemblySplitMode?: AssemblySplitModeType;
  },
): Promise<CheckPartDto | null> => {
  const response = await api.parts.check.mutation({
    params: {
      id,
    },
    body: {
      force,
      analyzeType,
      partType,
      shouldUpdatePartType,
      shouldPredictAfterAnalyze,
      quoteRequestLineId,
      assemblySplitMode,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Erreur lors de la vérification de la pièce", response.status, response.body);
};
